import React from 'react';
import { User as UserIcon } from 'lucide-react';

interface SettingsProfileProps {
  user: any;
}

export function SettingsProfile({ user }: SettingsProfileProps) {
  return (
    <section>
      <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-3">Account Information</h3>
      {user ? (
        <div className="bg-slate-50 dark:bg-slate-900/50 p-4 rounded-xl border border-slate-100 dark:border-slate-800 flex items-center gap-3">
          {user.photoURL ? (
            <img src={user.photoURL} loading="lazy" alt="Avatar" className="w-10 h-10 rounded-full border border-slate-200 dark:border-slate-700" />
          ) : (
            <div className="w-10 h-10 rounded-full bg-slate-200 dark:bg-slate-800 flex items-center justify-center text-slate-500">
              <UserIcon className="w-5 h-5" />
            </div>
          )}
          <div>
            <p className="text-xs text-slate-500 dark:text-slate-400 mb-0.5">Signed in as</p>
            <p className="font-medium text-sm text-slate-900 dark:text-white">{user.email}</p>
          </div>
        </div>
      ) : (
        <p className="text-sm text-slate-600 dark:text-slate-400">You are not signed in.</p>
      )}
    </section>
  );
}
